import token, { tokenToVars } from '../token';
import Progress from './progress';

export { Progress };
export default tokenToVars(Progress, token);
